import React, { useEffect } from "react";
import { toPX } from "../logic/WidgetUtils";

// Externals
import cn from "classnames";
import { Resizable } from "re-resizable";
import "../../components/ViewportContainer/Task/react-resizable-hack.css"   //this is a css hack for <Resizable>

//Component styles
import classes from "./SplitWidget.module.scss";

export function SplitWidget(props) {
  const { ui, data, createChildWidget, doAction } = props;

  let widgetId = ui.id;
  let content = data && data.content ? JSON.parse(data.content) : null;
  let firstIsCollapsed = content ? content.Part1Collapsed : "";
  let secondIsCollapsed = content ? content.Part2Collapsed : "";

  useEffect(() => {
    console.log("SplitWidget data of " + ui.id + ": ", data);
  }, [data]);

  const renderChildWidget = index => {
    let childWidgetUi = ui.containingWidgets[index];
    return childWidgetUi ? createChildWidget(childWidgetUi) : null;
  };

  const onDividerButtonClick = (e) => {
    e.stopPropagation();
    expandOrCollapse();
  };

  const onTogglerButtonClick = (e) => {
    e.stopPropagation();
    expandOrCollapse();
  };

  const expandOrCollapse = () => {
    let actionId = firstIsCollapsed ? "EXPAND" : "COLLAPSE";
    doAction(actionId, "0");
  };

  const onDividerMouseOver = (e) => {
    if (e.target && e.target.firstChild) {
      setVisibility(e.target.firstChild, "visible");
    }
  };

  const onDividerMouseLeave = (e) => {
    if (e.target && e.target.firstChild) {
      setVisibility(e.target.firstChild, "hidden");
    }
  };

  const onTogglerMouseLeave = (e) => {
    if (e.target) {
      setVisibility(e.target, "hidden");
    }
  };

  const setVisibility = (element, value) => {
    if (element) {
      element.style.visibility = value;
    }
  };

  const resizerSize = () => {
    return (firstIsCollapsed)
      ? { width: 0, height: "100%" }
      : { height: "100%" }
  };

  const resizerMinWidth = () => {
    return (firstIsCollapsed)
      ? 0
      : toPX(ui.containingWidgets[0].width)
  };

  return (
    <div id={widgetId} className={classes.splitWrapper}>
      <div className={classes.leftPane} style={{ overflow: "auto" }} >
        <Resizable
          style={{ overflow: "hidden" }}
          enable={{ right: true }}
          size={resizerSize()}
          minWidth={resizerMinWidth()}
        >
          {firstIsCollapsed ? null : renderChildWidget(0)}
        </Resizable>
      </div>
      <div
        className={cn(classes.dividerPane, "dx-theme-border-color-as-background-color")}
        onMouseOver={(e) => onDividerMouseOver(e)}
        onMouseLeave={(e) => onDividerMouseLeave(e)}
        onClick={(e) => onDividerButtonClick(e)}
      >
        <div
          className={cn(
            classes.toggler,
            "dx-theme-border-color",
            firstIsCollapsed ? "dx-icon-chevronright" : "dx-icon-chevronleft"
          )}
          style={{ visibility: "hidden" }}
          onMouseLeave={(e) => onTogglerMouseLeave(e)}
          onClick={(e) => onTogglerButtonClick(e)}
        />
      </div>
      <div className={classes.rightPane} style={{ overflow: "auto" }}>
        {secondIsCollapsed ? null : renderChildWidget(1)}
      </div>
    </div>
  );
}
